
import {
	GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION,
	UPDATE_CENTER_CONFIGURATION,
	GET_ERRORS
} from "../actions/types";

const initialState = {
	centerConfiguration : null,
	actionType: "",
	error: ""
};

export default function (state = initialState, action) {
	switch (action.type) {

		case GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION:
			return {
				...state,
				actionType: action.type,
				centerConfiguration: action.payload
			};
		case UPDATE_CENTER_CONFIGURATION:
			return {
				...state,
				actionType: action.type
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload
			};

		default:
			return state;
	}
}
